import { makeStyles, Container } from '@material-ui/core'
import { useTranslation } from 'next-i18next'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// TQM car-insurance promo click-through — the SAME link the old design already
// uses on its TQM banner (components/tracking/DetailCard.js).
const TQM_PROMO_URL =
  'https://www.tqm.co.th/car-insurance/online?utm_source=affiliate&utm_medium=mysave&utm_campaign=onlineshippop'

// Full-width rounded promo banner. The design mockup shows a fixed TQM car-
// insurance banner here, and the user asked for it as a STATIC image (so it
// matches the design and always shows) rather than the server-driven
// externalBanner/LL_Tracking ad slot, which renders empty in local dev. The
// asset (tqm.png/.webp, natural 3825×1066) lives in /static/img/tracking-new.
// NOTE: only this ?new variant uses the static image; the old (no ?new)
// /tracking page still renders LL_Tracking, so its behaviour is unchanged.
const useStyles = makeStyles((theme) => ({
  section: {
    padding: '16px 0 8px',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 0 4px',
    },
  },
  frame: {
    display: 'block',
    cursor: 'pointer',
    borderRadius: T.radius.xl,
    overflow: 'hidden',
    boxShadow: T.shadow.card,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': { transform: 'translateY(-2px)', boxShadow: T.shadow.lg },
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
      borderRadius: T.radius.xl,
    },
  },
}))

const TrackingPromoNew = () => {
  const classes = useStyles()
  const { t } = useTranslation('tracking')
  return (
    <section className={classes.section}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <a
            href={TQM_PROMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.frame}
          >
            <picture>
              <source
                srcSet="/static/img/tracking-new/tqm.webp"
                type="image/webp"
              />
              <img
                src="/static/img/tracking-new/tqm.png"
                alt={t('new.promo.img-alt')}
                width={3825}
                height={1066}
                loading="lazy"
                decoding="async"
              />
            </picture>
          </a>
        </Reveal>
      </Container>
    </section>
  )
}

export default TrackingPromoNew
